precision highp float;

uniform float uRand;

varying vec2 vUv;
varying vec3 vNormal;

#pragma glslify: blendAdd = require(glsl-blend/add)
#pragma glslify: fbm3d = require(glsl-fractal-brownian-noise/3d)

// vec2 noiseInterpolate(const in vec2 x) 
// { 
//     vec2 x2 = x * x;
//     return x2 * x * (x * (x * 6.0 - 15.0) + 10.0); 
// }

// uvec4 ihash1D(uvec4 q)
// {
//     // hash by Hugo Elias, Integer Hash - I, 2017
//     q = q * 747796405u + 2891336453u;
//     q = (q << 13u) ^ q;
//     return q * (q * q * 15731u + 789221u) + 1376312589u;
// }

// vec4 betterHash2D(vec4 cell)    
// {
//     uvec4 i = uvec4(cell);
//     uvec4 hash = ihash1D(ihash1D(i.xzxz) + i.yyww);
//     return vec4(hash) * (1.0 / float(0xffffffffu));
// }

// float noise(vec2 pos, vec2 scale, float phase, float seed) 
// {
//     const float kPI2 = 6.2831853071;
//     pos *= scale;
//     vec4 i = floor(pos).xyxy + vec2(0.0, 1.0).xxyy;
//     vec2 f = pos - i.xy;
//     i = mod(i, scale.xyxy) + seed;

//     vec4 hash = betterHash2D(i);
//     hash = 0.5 * sin(phase + kPI2 * hash) + 0.5;
//     float a = hash.x;
//     float b = hash.y;
//     float c = hash.z;
//     float d = hash.w;

//     vec2 u = noiseInterpolate(f);
//     float value = mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
//     return value * 2.0 - 1.0;
// }

// float fbm(vec2 pos, vec2 scale, int octaves, float shift, float timeShift, float gain, float lacunarity, float octaveFactor, float seed) 
// {
//     float amplitude = gain;
//     float time = timeShift;
//     vec2 frequency = scale;
//     vec2 offset = vec2(shift, 0.0);
//     vec2 p = pos * frequency;
//     octaveFactor = 1.0 + octaveFactor * 0.12;
    
//     vec2 sinCos = vec2(sin(shift), cos(shift));
//     mat2 rotate = mat2(sinCos.y, sinCos.x, sinCos.x, sinCos.y);

//     float value = 0.0;
//     for (int i = 0; i < octaves; i++) 
//     {
//         float n = noise(p / frequency, frequency, time, seed);
//         value += amplitude * n;
        
//         p = p * lacunarity + offset * float(1 + i);
//         frequency *= lacunarity;
//         amplitude = pow(amplitude * gain, octaveFactor);
//         time += timeShift;
//         offset *= rotate;
//     }
//     return value * 0.5 + 0.5;
// }

// float map(float value, float min1, float max1, float min2, float max2) {
//   return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
// }

float dist(vec2 p0, vec2 pf){return sqrt((pf.x-p0.x)*(pf.x-p0.x)+(pf.y-p0.y)*(pf.y-p0.y));}

void main() {

    float d = dist(vec2(1024.)*0.5,gl_FragCoord.xy)*(0.001+uRand);
    float a = mix(1., 0., d);

    gl_FragColor = vec4(blendAdd(vec3(0.6), vec3(1.) * fbm3d(vec3(vUv * 1., uRand), 6) * 0.9), 1.);
    gl_FragColor.rgb = mix(vec3(0.6), gl_FragColor.rgb, a);

//   gl_FragColor = vec4(vec3(0.) + fbm(vUv, vec2(2), 6, 0., 0., 0.5, 5., -0.5, 0.), 1.);
  // vec2 pos, vec2 scale, int octaves, float shift, float timeShift, float gain, float lacunarity, float octaveFactor, float seed
}